import { render, staticRenderFns } from "./DocenteNovedades.vue?vue&type=template&id=0a825e3e&"
import script from "./DocenteNovedades.vue?vue&type=script&lang=js&"
export * from "./DocenteNovedades.vue?vue&type=script&lang=js&"
import style0 from "./DocenteNovedades.vue?vue&type=style&index=0&id=0a825e3e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports